import { httpClient } from '../api/http-client';

const API_BASE = '/cash-register';

export interface CierrePayload {
  fecha: string;
  vendedorId?: string;
  totalVentas: number;
  totalContado: number;
  diferenciaTotal: number;
  efectivoVentas: number;
  efectivoContado: number;
  tarjetaVentas: number;
  tarjetaContado: number;
  transferenciasVentas: number;
  transferenciasContado: number;
  nequiVentas: number;
  nequiContado: number;
  cantidadVentas: number;
}

export interface UpdateCierrePayload {
  efectivoContado?: number;
  tarjetaContado?: number;
  transferenciasContado?: number;
  nequiContado?: number;
}

export interface CierreResponse {
  success: boolean;
  data: {
    cerrado: boolean;
    cierre: {
      id: string;
      fecha: string;
      usuarioId: string;
      vendedorId: string | null;
      totalVentas: number;
      totalContado: number;
      diferenciaTotal: number;
      efectivoVentas: number;
      efectivoContado: number;
      tarjetaVentas: number;
      tarjetaContado: number;
      transferenciasVentas: number;
      transferenciasContado: number;
      nequiVentas: number;
      nequiContado: number;
      cantidadVentas: number;
      creadoEn: string;
      usuario: {
        id: string;
        nombreCompleto: string;
        email: string;
      };
    } | null;
  };
}

export interface ClosureItem {
  id: string;
  fecha: string;
  usuarioId: string;
  vendedorId: string | null;
  totalVentas: number;
  totalContado: number;
  diferenciaTotal: number;
  efectivoVentas: number;
  efectivoContado: number;
  tarjetaVentas: number;
  tarjetaContado: number;
  transferenciasVentas: number;
  transferenciasContado: number;
  nequiVentas: number;
  nequiContado: number;
  cantidadVentas: number;
  creadoEn: string;
  usuario?: {
    id: string;
    nombreCompleto: string;
    email: string;
  };
  margenBruto: number;
  costoTotal: number;
}

export interface ClosuresResponse {
  success: boolean;
  data: ClosureItem[];
  meta: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export class CashRegisterService {
  static async checkStatus(fecha: string, vendedorId?: string): Promise<CierreResponse> {
    const params = new URLSearchParams();
    params.append('fecha', fecha);
    if (vendedorId) params.append('vendedorId', vendedorId);
    const response = await httpClient.get<CierreResponse>(`${API_BASE}/status?${params.toString()}`);
    return response.data;
  }

  static async close(payload: CierrePayload): Promise<{ success: boolean; data: any; message: string }> {
    const response = await httpClient.post<{ success: boolean; data: any; message: string }>(`${API_BASE}/close`, payload);
    return response.data;
  }

  static async getClosures(params?: {
    page?: number;
    limit?: number;
    desde?: string;
    hasta?: string;
    vendedorId?: string;
  }): Promise<ClosuresResponse> {
    const search = new URLSearchParams();
    if (params?.page) search.append('page', String(params.page));
    if (params?.limit) search.append('limit', String(params.limit));
    if (params?.desde) search.append('desde', params.desde);
    if (params?.hasta) search.append('hasta', params.hasta);
    if (params?.vendedorId) search.append('vendedorId', params.vendedorId);
    const query = search.toString();
    const response = await httpClient.get<ClosuresResponse>(`${API_BASE}/closures${query ? '?' + query : ''}`);
    return response.data;
  }

  static async updateClosure(id: string, payload: UpdateCierrePayload): Promise<{ success: boolean; data: ClosureItem; message: string }> {
    const response = await httpClient.patch<{ success: boolean; data: ClosureItem; message: string }>(`${API_BASE}/${id}`, payload);
    return response.data;
  }

  static async deleteClosure(id: string): Promise<{ success: boolean; message: string }> {
    const response = await httpClient.delete<{ success: boolean; message: string }>(`${API_BASE}/${id}`);
    return response.data;
  }
}
